import React from 'react';
import styles from '../styles/DecisionTool.styles';

const ProfitMarginTable = ({
    profitMarginLevel,
    setProfitMarginLevel,
    calculateProfitMarginPercentage,
    calculateCostPerBike,
    calculateProfitMarginPerBike,
    calculatePricePerBike,
    roundNumber,
}) => {

    return (
        <div>
            {/* PROFIT MARGIN */}
            <div className={styles.profitMarginSection}>
                <h2>Input Profit Margin: Calculate Retail Price</h2>

                {/* Profit Margin Selector */}
                <div className={styles.row}>
                    <label className={styles.profitLabel}>Profit Margin (1-5): </label>
                    <select
                        style={{
                            borderRadius: '4px',
                            padding: '4px 10px',
                            border: '1px solid #ccc',
                            outline: 'none',
                        }}
                        value={profitMarginLevel}
                        onChange={(e) => setProfitMarginLevel(parseInt(e.target.value))}
                        className={styles.input}
                    >
                        {[1, 2, 3, 4, 5].map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>

                <p></p>

                {/* Profit Margin Percentage - no bullets */}
                <div className={styles.row}>
                    <label className={styles.profitLabel}> Profit Margin (%): </label>
                    <span className={styles.valueText}>{calculateProfitMarginPercentage()}%</span>
                </div>

                <p></p>

                {/* Cost Per Bike */}
                <div className={styles.row}>
                    <label className={styles.profitLabel}>Cost Per Bike: </label>
                    <span className={styles.valueText}>${calculateCostPerBike()}</span>
                </div>

                <p></p>

                {/* Profit Margin Per Bike in Dollars */}
                <div className={styles.row}>
                    <label className={styles.profitLabel}>Profit Margin per Bike ($): </label>
                    <span className={styles.valueText}>${calculateProfitMarginPerBike()}</span>
                </div>

                <p></p>

                {/* Price Per Bike */}
                <div className={styles.row}>
                    <label className={styles.profitLabel}>Price Per Bike: </label>
                    <span className={styles.valueText}>${calculatePricePerBike()}</span>
                </div>

            </div>

            <div>
                <p></p>
            </div>
        </div>
    );
};

export default ProfitMarginTable;
